import { Injectable } from '@angular/core';
import { BaseHttpService, PageResponse } from './base-capacitor-http';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthResponse, EncryptedData, LoginCredential, UpdateResponse, UserInfo } from './auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';


export class UserDisplay{
  id: string;
  username: string;
  role: string;
  email: string;
  verified: boolean;
  disabled: boolean;
  selected?: boolean = false;
  password?: string;
  confirmPassword?: string;
}

export class UserStats{
  total: number;
  active: number;
  disabled: number;
  verified: number;
  
}

export class MemberSearchParams{
  page: number = 0;
  size: number = 10;
  search: string;
  role: string;
  verified: boolean = null;
  disabled: boolean = null;

}

@Injectable({
  providedIn: 'root'
})
export class UserManagementService extends BaseHttpService {

  private readonly baseUrl: string;
  private urlEndPoint: string;

  constructor(client: HttpClient, snackbar: MatSnackBar) {
    super(client, snackbar);
    this.baseUrl = environment.server.mainURL;
  }

  async getUserStats(){
    this.urlEndPoint = this.baseUrl + 'members/admin/user-stats';
    return this.get<UserStats>(this.urlEndPoint);
  }

  async checkUsernameExists(username: string){
    this.urlEndPoint = this.baseUrl + 'members/admin/check-username';
    const payload = {
      username: username
    }
    
    let body = {
      payload: this.encrypt<any>(payload, this.KEY) 
    };
    return this.post<boolean>(this.urlEndPoint, body);
  }

  async checkEmailExists(email: string){
    this.urlEndPoint = this.baseUrl + 'members/admin/check-email';
    const payload ={
      email: email
    }
    let body = {
      payload: this.encrypt<any>(payload, this.KEY)
    };
    return this.post<boolean>(this.urlEndPoint, body);
  }

  async getAllMemberData(params: MemberSearchParams){
    this.urlEndPoint = this.baseUrl + 'members/admin/user';
    const encryptedData = await this.get<EncryptedData>(this.urlEndPoint, params);
    return this.decryptResponse<PageResponse<UserDisplay>>(encryptedData.payload, this.KEY, encryptedData.iv);
  }

  async registerMember(user: UserDisplay){
    this.urlEndPoint = this.baseUrl + 'members/admin/register';
   
    let body = {
      payload: this.encrypt<UserDisplay>(user, this.KEY),
      url: environment.server.domain
    };
    return this.post<AuthResponse>(this.urlEndPoint, body);
  }

  async updateMember(user: UserDisplay){
    this.urlEndPoint = this.baseUrl + 'members/admin/user';
    let body ={
      payload: this.encrypt<UserDisplay>(user, this.KEY)
    }
    const encryptedData = await this.put<EncryptedData>(this.urlEndPoint, body);
    return this.decryptResponse<UserDisplay>(encryptedData.payload, this.KEY, encryptedData.iv);
  }

  async deleteMember(userId: string){
    this.urlEndPoint = this.baseUrl + 'members/admin/user/' + userId;
    return this.delete<boolean>(this.urlEndPoint);
  }

  async bulkUpdate(update: string, users: UserDisplay[]){
    this.urlEndPoint = this.baseUrl + 'members/admin/bulk-update';
    let body = {
      payload: this.encrypt<UserDisplay[]>(users, this.KEY)
    }
    const encryptedData = await this.put<EncryptedData>(this.urlEndPoint, body, { update: update} );
    return this.decryptResponse<UserDisplay[]>(encryptedData.payload, this.KEY, encryptedData.iv);
  }
  
  async loadUserInfo(){
    this.urlEndPoint = this.baseUrl + 'members/info';
    const encryptedData = await this.get<EncryptedData>(this.urlEndPoint);
    return this.decryptResponse<UserInfo>(encryptedData.payload, this.KEY, encryptedData.iv);
  }
  
  async updateUsername(username: string): Promise<UpdateResponse>{
    this.urlEndPoint = this.baseUrl + 'members/username-update';
    let body = {
      username: username
    }
  
    return this.post(this.urlEndPoint, body);
  }
  
  async checkAccountStatus(): Promise<AuthResponse>{
    this.urlEndPoint =  this.baseUrl + 'members/account-status';
    return this.get<AuthResponse>(this.urlEndPoint);
  }
  
  async reAuthenticate(credential: LoginCredential){
    let key = environment.server.key;
    this.urlEndPoint = this.baseUrl + 'members/re-authenticate';
  
    let body = {
      payload: this.encrypt<LoginCredential>(credential, key)
    }
  
    return this.post<AuthResponse>(this.urlEndPoint, body);
  }
  
  async accountDeletionRequest(){
    this.urlEndPoint = this.baseUrl + 'members/deletion-request';
    let body = {
      url: environment.server.domain
    };
  
    return this.post<UpdateResponse>(this.urlEndPoint, body);
  }
  
  async getUserHashedEmail(){
    this.urlEndPoint = this.baseUrl + 'members/masked-email';
    return this.get<{email: string}>(this.urlEndPoint);
  }
  
  async updatePassword(password: string, newPassword: string){
    this.urlEndPoint = this.baseUrl + 'members/update-password';
    let body = {
      password: this.hashValue(password),
      newPassword: this.hashValue(newPassword)
    }
    return this.post<boolean>(this.urlEndPoint, body);
  }
  

  




  


}
